import { z } from 'zod';

/** `GET /api/health` */
export const Health = z.object({
  status: z.enum(['ok', 'error']),
  db: z.enum(['ok', 'error']),
  version: z.string(),
});
export type Health = z.infer<typeof Health>;
